// cancel-requests.service.ts
import { Injectable } from '@angular/core';
import { langs } from 'projects/shared/models/category';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CancelRequestsService {
  maintenanceModeData = new BehaviorSubject<{title: langs, body: langs}>(null!)
  private cancelPendingRequests$ = new Subject<void>();

  get onCancelPendingRequests() {
    return this.cancelPendingRequests$.asObservable();
  }

  cancelAll(): void {
    this.cancelPendingRequests$.next();
  }
}